<template>
    <div class="buttons">
        <Notifications v-if="isAuthorized" :user-id="userId" />

        <router-link v-if="isAuthorized" :to="{ name: 'account' }">
            <Avatar v-if="isMobile" />
            <span v-else class="buttons__text">{{ fullName }}</span>
        </router-link>

        <router-link v-else class="buttons__auth button" :to="{ name: 'account' }">
            {{ loginButtonText }}
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Notifications from './Notifications';
import Avatar from './Avatar';

const getters = ['isMobile', 'userProfileInfo'];
const userGetters = ['userDisplayName', 'userId', 'isAuthorized'];

export default {
    name: 'Buttons',
    components: {
        Notifications,
        Avatar,
    },
    computed: {
        ...mapGetters(getters),
        ...mapGetters('auth', userGetters),

        loginButtonText() {
            return this.isMobile ? 'Войти' : 'Личный кабинет';
        },
        fullName() {
            if (this.isAuthorized) {
                if (!this.userProfileInfo.name || !this.userProfileInfo.surname) {
                    return '';
                }

                const fullName = `${this.userProfileInfo.name} ${this.userProfileInfo.surname}`;
                return fullName.length > 20 ? this.userProfileInfo.name : fullName;
            }
            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mrem';
@import '../../styles/rem';
@import '../../styles/variables';
@import '~@/styles/buttons_v2.scss';

.buttons {
    font-family: $font-montserrat;
    display: flex;
    align-items: center;
    height: 100%;

    > * {
        margin-left: mrem(16);
        @include on-desktop {
            margin-left: rem(24);
        }
    }

    &__text {
        user-select: none;
        cursor: pointer;
        font-family: GolosText, sans-serif;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: mrem(150);
        flex: 1;
        font-size: mrem(18);
        line-height: mrem(26);
        text-align: right;

        @include on-desktop {
            max-width: none;
            display: inline-block;
            font-size: rem(22);
            line-height: rem(26);
            text-align: left;
            padding-top: rem(3);
        }

        @media (max-width: $md  * 1px) and (min-width: 1023px) {
            padding-top: rem(5);
        }

        &:hover {
            color: #4663ab;
        }
    }

    &__auth {
        font-weight: 500;
        font-family: GolosText, sans-serif;
        font-size: urem(16);
        padding: urem(10) 0;
        background: none;
        border: none;
        color: var(--color-primary);

        @include on-desktop {
            background: var(--color-primary);
            font-weight: 600;
            font-size: urem(14);
            padding: urem(14) urem(32);
            color: white;
        }
    }
}
</style>
